<div class="File-uploader flex flex-col flex-1">
  <div class="Droparea flex-1 flex flex-col items-center justify-center" [ngClass]="{ 'w-[300px]': files.length }">
    <mat-icon class="Droparea__icon">cloud_upload</mat-icon>
    <h3 class="Droparea__title">{{ 'MEDIA.DROP_FILES' | translate }}</h3>
    <p class="Droparea__or mb-3">{{ 'COMMON.OR' | translate }}</p>
    <button class="Droparea__button" mat-raised-button color="primary">
      <label style="margin-bottom: 0">
        <input type="file" ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" multiple />
        {{ 'MEDIA.PICK_FILES' | translate }}
      </label>
    </button>
  </div>
  <div class="Uploader flex-auto" [hidden]="!files.length">
    <div class="File-list">
      <div class="File-list__item File flex items-center justify-start gap-3" *ngFor="let file of files">
        <div class="File__body flex flex-col flex-1">
          <p class="File__name">{{ file.name }}</p>
          <mat-progress-bar class="File__progressbar" mode="determinate" [value]="file?.progress?.data?.percentage"></mat-progress-bar>
          <div class="File__meta flex">
            <span>{{ humanFileSize(file.size) }}</span>
            <span [hidden]="file?.progress?.status !== 2">{{ 'MEDIA.UPLOAD_COMPLETE' | translate }}</span>
            <span [hidden]="file?.progress?.status !== 3">{{ 'MEDIA.CANCELED' | translate }}</span>
            <span [hidden]="file?.progress?.status !== 1">{{ file?.progress?.data?.speedHuman }}</span>
            <span [hidden]="file?.progress?.status !== 1">{{ file?.progress?.data?.etaHuman }}</span>
          </div>
        </div>
        <div class="File__actions">
          <button mat-icon-button (click)="cancelUpload(file.id)" [hidden]="file?.progress?.status !== 1"><mat-icon>stop</mat-icon></button>
          <button mat-icon-button (click)="removeFile(file.id)" [hidden]="file?.progress?.status === 2"><mat-icon>clear</mat-icon></button>
        </div>
      </div>
    </div>
  </div>
</div>
